<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <div class="label-title">数据标签详情</div>
      <el-row class="mt-10px">
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-select
          v-model="classId"
          clearable
          filterable
          placeholder="请选择实体数据表"
          size="small"
          class="w-200px mr-10px ml-10px"
        >
          <el-option
            v-for="item in classIdList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="attributeId"
          clearable
          filterable
          placeholder="请选择属性"
          size="small"
          class="w-200px mr-10px"
        >
          <el-option
            v-for="item in attributeList"
            :key="item.columnName"
            :label="item.name"
            :value="item.columnName"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          filterable
          v-model="symbolValue"
          :placeholder="`${$t('pleaseSelect')}`"
          class="w-200px mr-10px"
        >
          <el-option
            v-for="item in symbolList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          size="small"
          v-model="keyWord"
          placeholder="输入搜索关键字"
          clearable
          class="w-200px mr-10px"
        />
        <el-button type="primary" size="small" @click="searchTableData()">搜索</el-button>
        <el-button size="small" @click="reset">重置</el-button>
        <el-button type="primary" size="small" @click="batchLabel">批量标签</el-button>
        <el-button
          type="primary"
          size="small"
          @click="saveLabel"
          :loading="saveLoading"
          :disabled="disabledSave"
          >保存</el-button
        >
      </el-row>
      <el-table
        border
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        @selection-change="handleSelectionChange"
        height="calc(100% - 144px)"
        class="mt-20px"
        ref="tableRef"
      >
        <el-table-column v-if="listHeader.length" type="selection" width="55"></el-table-column>
        <el-table-column
          v-for="(item, index) in listHeader"
          :key="index"
          :label="item.name"
          :prop="item.column"
          show-overflow-tooltip
          min-width="150"
        >
          <template slot-scope="scoped">
            <div v-if="_.includes(viewList, item.column)">
              <span>{{ scoped.row[item.column] }}</span>
              <el-tooltip :content="$t('查看文件')" class="m-l-10">
                <el-button
                  class="iconfont icon-display"
                  type="primary"
                  @click="viewFile(scoped.row, item.column)"
                ></el-button>
              </el-tooltip>
            </div>
            <div v-else>{{ scoped.row[item.column] }}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="listHeader.length" label="数据标签" fixed="right" width="600">
          <template slot-scope="scoped">
            <el-select
              v-model="scoped.row.labelId"
              clearable
              filterable
              placeholder="数据标签"
              size="mini"
              multiple
              @change="changeLabel(scoped.row)"
              class="w-full"
            >
              <el-option
                v-for="item in labelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <!-- <span v-for="(item, index) in scoped.row.labelName" :key="index" class="m-l-5">
            <el-tag>{{ item }}</el-tag>
          </span> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordCount"
      ></el-pagination>
    </el-card>

    <!-- 查看文件 -->
    <el-dialog
      :width="uploadFileTitle === $t('upload') ? '400px' : '1200px'"
      :top="isFullScreen ? '0' : '15vh'"
      id="viewDialog"
      :title="uploadFileTitle"
      :visible.sync="uploadFileVisible"
      v-dialogDrag
    >
      <i
        @click="fullScreen()"
        v-show="uploadFileTitle !== $t('upload')"
        v-if="!isFullScreen"
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <i
        v-show="uploadFileTitle !== $t('upload')"
        @click="exitFullScreen()"
        v-else
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <div style="height: 520px" id="fileView" v-loading="loadingFile">
        <img :src="viewUrl" class="w-full h-full" v-if="isImg" />
        <iframe v-else :src="viewUrl" class="w-full h-full"></iframe>
      </div>
    </el-dialog>

    <!-- 批量标签 -->
    <el-dialog width="1200px" title="批量选择标签" :visible.sync="showBatchLabel" v-dialogDrag>
      <el-row class="flex">
        <el-input
          size="small"
          placeholder="标签代码"
          v-model.trim="code"
          clearable
          class="w-200px mr-10px"
        />
        <el-input
          size="small"
          placeholder="标签名称"
          v-model.trim="name"
          clearable
          class="w-200px mr-10px"
        />
        <el-button type="primary" size="small" @click="getLabelData()">搜索</el-button>
        <el-button size="small" @click="resetLabel">重置</el-button>
      </el-row>
      <el-table
        border
        :data="labelData"
        v-loading="labelLoading"
        @selection-change="selectLabel"
        height="400"
        ref="multipleTable"
        class="mt-20px"
      >
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="$t('labelCode')"
          prop="name"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="$t('labelName')"
          prop="code"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('remarks')}`"
          prop="remark"
        ></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="batchSave" :loading="saveBatchLoading">{{
          $t('save')
        }}</el-button>
        <el-button @click="showBatchLabel = false">
          {{ $t('cancel') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import StdClassTreeService from '@/services/StdClassTreeService'
import StdClassAttributeService from '@/services/StdClassAttributeService'
import dataLabelManagementService from '@/services/dataLabelManagementService'
import MasterDataManageService from '@/services/masterDataManageService'
import assetService from '@/services/assetService'
import StdAttrBusinessOperation from '@/services/bsApi/StdAttributeBusinessOperation'
import selectStandardId from '../../components/selectStandardId'

export default {
  components: { selectStandardId },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      classId: '', // 类别id
      tableName: '',
      classIdList: [],
      attributeId: '', // 属性id
      attributeList: [],
      symbolValue: '', // 符号
      symbolList: [
        { value: '$eq', name: '等于' },
        { value: '$ne', name: '不等于' },
        { value: '$gt', name: '大于' },
        { value: '$gte', name: '大于等于' },
        { value: '$lt', name: '小于' },
        { value: '$lte', name: '小于等于' },
        { value: '$text', name: '包含' },
        { value: '$ntext', name: '不包含' },
        // { value: '$in', name: '在范围内' },
        // { value: '$nin', name: '不在范围内' },
      ],
      keyWord: '', // 关键字
      labelId: [], // 标签id
      labelList: [],
      listHeader: [],
      tableData: [],
      tableLoading: false,
      selectionList: [],
      pageNo: 0,
      pageSize: 15,
      recordCount: 0,
      saveLoading: false,
      selectedId: '',
      browseItem: '',
      uploadFileTitle: '',
      uploadFileVisible: false,
      isFullScreen: false,
      loadingFile: false,
      viewUrl: '',
      isImg: false,
      opereateList: [],
      viewList: [],
      imgExt: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tif'],
      showBatchLabel: false,
      name: '', // 标签名称
      code: '', // 标签代码
      labelLoading: false,
      selectLabelList: [],
      saveBatchLoading: false,
      labelData: [],
      singleLabel: [],
      disabledSave: true,
    }
  },
  methods: {
    // 获取标签列表
    async getLabelData() {
      const parameter = {
        Name: this.name,
        Code: this.code,
        SkipCount: 1,
        MaxResultCount: 999,
      }
      this.labelLoading = true
      const res = await dataLabelManagementService.list(parameter)
      this.labelLoading = false
      if (res && res.code === 0 && res.data) {
        this.labelData = res.data
      }
    },
    // 批量保存
    async batchSave() {
      if (this.selectLabelList.length === 0) {
        this.$message.warning('请选择标签')
      } else {
        const params = []
        _.map(this.selectionList, (item) => {
          _.map(this.selectLabelList, (lItem) => {
            params.push({
              dataId: item.id,
              labelId: lItem.id,
              dataTableName: this.tableName,
            })
          })
        })
        this.saveBatchLoading = true
        const res = await dataLabelManagementService.updateEntityLabels(params)
        this.saveBatchLoading = false
        if (res && res.code === 0) {
          this.showBatchLabel = false
          this.$message.success('保存成功')
          this.searchTableData()
        }
      }
    },
    // 重置标签查询条件
    resetLabel() {
      this.code = ''
      this.name = ''
      this.getLabelData()
    },
    // 批量选择标签
    selectLabel(val) {
      this.selectLabelList = val
    },
    // 批量标签
    batchLabel() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择要打标签的数据')
        return
      }
      this.showBatchLabel = true
      this.resetLabel()
    },
    updateStandardId(val) {
      this.standardId = val
    },
    // 获取上传，删除，查看权限
    async findAttrConfig() {
      // 获取属性配置信息
      const res = await StdAttrBusinessOperation.find({
        class_id: this.classId,
        pageno: 1,
        pagesize: 999,
        standard_id: this.standardId,
        attribute_id: '',
      })
      if (res && res.code === 0 && res.data) {
        this.opereateList = res.data
      }
    },
    upDateAttributeList() {
      // 更新编码列表
      // 判断是否为操作列
      this.viewList = []
      _.forEach(this.attributeList, (item) => {
        _.forEach(this.opereateList, (cItem) => {
          if (
            cItem.attributeName === item.name &&
            cItem.businessOperationName === '打开文件' &&
            cItem.presentationTypeStr === '列按钮'
          ) {
            this.viewList.push(item.columnName)
          }
        })
      })
      this.viewList = [...new Set(this.viewList)]
    },
    exitFullScreen() {
      this.isFullScreen = false
      this.exitFullscreen()
      if (this.uploadFileTitle === this.$t('upload')) {
        $('#viewDialog .el-dialog')
          .width(400)
          .height(280)
        $('#fileView').height(215)
        return
      }
      $('#viewDialog .el-dialog')
        .width(1200)
        .height(600)
      $('#fileView').height(515)
    },
    // 判断浏览器种类
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    fullScreen() {
      this.isFullScreen = true
      this.launchFullscreen(document.getElementById('viewDialog'))
    },
    // 判断各种浏览器，找到正确的方法
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
      $('#viewDialog .el-dialog')
        .width(window.screen.width)
        .height(window.screen.height)
      $('#fileView').height(window.screen.height - 100)
    },
    async getFileId(id) {
      // 1.先通过当前记录的id拿到fileId
      const res = await assetService.getFileId({ ownerId: this.selectedId, stepId: id })
      if (res.length > 0) {
        this.browseItem = res[res.length - 1]
      } else {
        this.browseItem = null
      }
    },
    async viewFile(row, column) {
      this.selectedId = row.id
      let stdClassAttributeId = null
      _.map(this.attributeList, (item) => {
        if (item.columnName === column) stdClassAttributeId = item.id
      })
      await this.getFileId(stdClassAttributeId)
      if (this.browseItem !== null) {
        $('#viewDialog .el-dialog').height(600)
        this.uploadFileTitle = this.$t('view')
        this.uploadFileVisible = true
        this.loadingFile = true
        // 通过fileId拿到返回的文件流
        if (_.includes(this.imgExt, this.browseItem.fileType.split('.')[1])) {
          // png
          this.isImg = true
          const resData = await assetService.browsePNG({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'image/jpeg' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        } else {
          // pdf
          this.isImg = false
          const resData = await assetService.browsePDF({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        }
      } else {
        this.$message.warning('没有上传文件')
      }
    },
    // 获取实体列表
    async getClassList() {
      this.classIdList = []
      const parameter = {
        standard_id: this.standardId,
        keyword: '',
        dynamic_column_name: '业务主题域',
        approve_status: 1,
      }
      const res = await StdClassTreeService.getTreeListNew(parameter)
      if (res && res.code === 0 && res.data) {
        this.classIdList = res.data
        if (this.classId === '') {
          this.classId = this.classIdList[0].id
        }
      }
    },
    // 获取属性列表
    async getAttributeList() {
      this.attributeList = []
      const params = {
        class_id: this.classId,
        keyword: '',
      }
      const res = await StdClassAttributeService.detail(params)
      if (res && res.code === 0 && res.data) {
        this.attributeList = res.data
        this.upDateAttributeList()
      }
    },
    // 获取标签列表
    async getLabelList() {
      const parameter = {
        SkipCount: 1,
        MaxResultCount: 999,
      }
      const res = await dataLabelManagementService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.labelList = res.data
      }
    },
    reset() {
      this.attributeId = ''
      this.symbolValue = ''
      this.keyWord = ''
      this.labelId = ''
      this.tableData = []
      this.searchTableData()
    },
    async searchTableData() {
      this.singleLabel = []
      this.disabledSave = true
      const parameter = {
        class_id: this.classId,
        pageno: this.pageNo,
        pagesize: this.pageSize,
        isAddTagOrDocument: false, // 不要位号或文档的数据
        label: 1, // 是否启动标签展示：【0：否】【1：是】
        // label_id: this.labelId,
      }
      if (this.symbolValue !== '=' || this.symbolValue !== '') {
        const obj = {}
        obj[this.symbolValue] = this.keyWord
        parameter[this.attributeId] = obj
      } else {
        parameter[this.attributeId] = this.keyWord
      }
      this.tableLoading = true
      const res = await MasterDataManageService.getmasterDataList(parameter)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.listHeader = _.filter(res.data.headers, (item) => {
          return item.name !== '数据标签'
        })
        this.tableData = _.map(res.data.datas, (item, index) => {
          if (!item.labelId) {
            item.labelId = []
            item.labelName = []
          } else {
            item.labelId = item.labelId.split(',')
            item.labelName = item.labelName.split(',')
          }
          item.index = index
          item.oldLabel = _.cloneDeep(item.labelId)
          return item
        })
        this.recordCount = res.page.recordCount
        this.$nextTick(() => {
          this.$refs.tableRef && this.$refs.tableRef.doLayout()
        })
      } else {
        this.$message.warning(res.msg)
      }
    },
    handleSelectionChange(val) {
      this.selectionList = val
    },
    handleCurrentChange(num) {
      this.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.searchTableData()
    },
    // 单个保存
    async saveLabel() {
      this.saveLoading = true
      const res = await dataLabelManagementService.updateEntityLabels(this.singleLabel)
      this.saveLoading = false
      if (res && res.code === 0) {
        this.$message.success('保存成功')
        this.searchTableData()
      }
    },
    changeLabel(row) {
      const labelName = []
      _.map(this.labelList, (item) => {
        if (_.includes(row.labelId, item.id)) {
          labelName.push(item.name)
        }
      })
      this.$set(this.tableData[row.index], 'labelName', labelName)
      // 是否有修改
      let flag = false
      // 是否有新增
      let hasAdd = false
      _.map(this.tableData, (item) => {
        if (item.id === row.id) {
          if (item.oldLabel.length > 0 && item.labelId.length === 0) {
            flag = true
            this.singleLabel.push({
              dataId: row.id,
              labelId: '',
              dataTableName: this.tableName,
            })
            hasAdd = false
          } else if (item.oldLabel.length === 0 && item.labelId.length > 0) {
            flag = true
            hasAdd = true
          } else if (item.oldLabel.length > 0 && item.labelId.length > 0) {
            _.map(item.oldLabel, (oItem) => {
              _.map(item.labelId, (lItem) => {
                if (oItem !== lItem) {
                  flag = true
                  hasAdd = true
                }
              })
            })
          }
        }
      })
      // 有修改，保存按钮可以编辑
      if (flag) {
        this.disabledSave = false
      }
      // 更新labelId
      _.map(row.labelId, (label) => {
        this.singleLabel.push({
          dataId: row.id,
          labelId: label,
          dataTableName: this.tableName,
        })
      })
      // labelId去重
      _.map(this.singleLabel, (item, index) => {
        _.map(this.singleLabel, (sItem, sIndex) => {
          if (
            item &&
            sItem &&
            item.dataId === sItem.dataId &&
            item.labelId === sItem.labelId &&
            index < sIndex
          ) {
            this.singleLabel.splice(sIndex, 1)
          }
        })
        if (hasAdd && item && item.dataId === row.id && !_.includes(row.labelId, item.labelId)) {
          this.singleLabel.splice(index, 1)
        }
        if (!hasAdd && item && item.dataId === row.id && item.labelId !== '') {
          this.singleLabel.splice(index, 1)
        }
      })
    },
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.classId = ''
        this.getClassList()
      }
    },
    async classId(newVal) {
      if (newVal) {
        this.attributeId = ''
        this.symbolValue = ''
        this.keyWord = ''
        this.labelId = ''
        this.searchTableData()
        await this.findAttrConfig()
        this.getAttributeList()
        _.map(this.classIdList, (item) => {
          if (item.id === newVal) this.tableName = item.tableName
        })
      }
    },
    attributeId(newVal) {
      if (newVal) {
        this.symbolValue = ''
        this.keyWord = ''
      }
    },
  },
  async created() {
    await this.getClassList()
    await this.getLabelList()
  },
}
</script>

<style lang="scss" scoped>

.icon-line-fullscreen {
  top: 23px;
  right: 45px;
}
.label-title {
  font-size: 20px;
  font-weight: 700;
}

</style>
